import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import {
  PageCategoryCO,
  PageCategoryType,
  PageCO,
  PageContentCO,
  SchoolCO
} from 'src/app/shared/models/ApiModels';
import { PageDataService } from 'src/app/shared/services/page-data.service';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { SchoolDetailsService } from 'src/app/shared/services/school-details.service';

export interface OtherPerson {
  imageUrl: string;
  name: string;
  designation: string;
  description: string;
}

@Component({
  selector: 'app-people-behind-vision',
  templateUrl: './people-behind-vision.component.html',
  styleUrls: ['./people-behind-vision.component.scss']
})
export class PeopleBehindVisionComponent implements OnInit, OnDestroy {

  director?: PageCategoryCO;
  directorContent?: PageContentCO;
  directorImage = '';

  principal?: PageCategoryCO;
  principalContent?: PageContentCO;
  principalImage = '';

  chairman?: PageCategoryCO;
  chairmanContent?: PageContentCO;
  chairmanImage = '';

  showChairmanMessage = false;
  showDirectorMessage = false;
  showPrincipalMessage = false;

  otherPeople: OtherPerson[] = [];

  secretary:any;
  secretaryImage = '';

  school: SchoolCO | null = null;



  loading$ = this.pageDataService.loading$;
  error$ = this.pageDataService.error$;

  private destroy$ = new Subject<void>();

  constructor(
    private pageDataService: PageDataService,
    private schoolService: SchoolDetailsService
  ) {}

  ngOnInit(): void {
    this.pageDataService.loadPageData();

    this.pageDataService.pageData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (!data?.length) return;

        const page = data[0]; // adjust if needed
        this.extractPeopleData(page);
      });

    this.schoolService.schoolState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state?.data) {
          this.school = state.data;
        }
      });
  }

  private extractPeopleData(page: PageCO): void {
    if (!page.category?.length) return;

    const map = new Map<PageCategoryType, PageCategoryCO>();
    page.category.forEach(cat => map.set(cat.category, cat));

    this.buildChairman(map);
    this.buildDirector(map);
    this.buildPrincipal(map);
    this.buildOtherPeople(map);
  }

  private buildChairman(map: Map<PageCategoryType, PageCategoryCO>): void {
    this.chairman = map.get(PageCategoryType.Chairman);
    this.chairmanImage = this.chairman?.image?.[0]
      ? this.getFileUrl(this.chairman.image[0].file.fileUUID)
      : '';
    this.chairmanContent = this.chairman?.content?.[0];
  }
  
  private buildDirector(map: Map<PageCategoryType, PageCategoryCO>): void {
    this.director = map.get(PageCategoryType.Director);
    this.directorImage = this.director?.image?.[0]
      ? this.getFileUrl(this.director.image[0].file.fileUUID)
      : '';
    this.directorContent = this.director?.content?.[0];
  }

  private buildPrincipal(map: Map<PageCategoryType, PageCategoryCO>): void {
    this.principal = map.get(PageCategoryType.Principal);
    this.principalImage = this.principal?.image?.[0]
      ? this.getFileUrl(this.principal.image[0].file.fileUUID)
      : '';
    this.principalContent = this.principal?.content?.[0];
  }

  private buildOtherPeople(map: Map<PageCategoryType, PageCategoryCO>): void {
    const category = map.get(PageCategoryType.OTHER_PEOPLE);

    this.otherPeople =
      category?.image?.map(img => ({
        imageUrl: this.getFileUrl(img.file.fileUUID),
        name: (img.file.title || '').split('-')[0],
        designation: (img.file.title || '').split('-')[1] || '',
        description: img.descp || ''
      })) ?? [];
  }

  private buildSecretary(map: Map<PageCategoryType, PageCategoryCO>): void {
    this.secretary = map.get(PageCategoryType.Secretary);
    this.secretaryImage = this.secretary?.image?.[0]
      ? this.getFileUrl(this.secretary.image[0].file.fileUUID)
      : '';
  }

  private getFileUrl(uuid: string): string {
    return `${ApiUrls.downloadFileUrl1}${uuid}`;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
